// extracted by mini-css-extract-plugin
var _1 = "NotificationsPopup_item__3h3ud";
var _2 = "NotificationsPopup_itemButton__effAQ";
var _3 = "NotificationsPopup_itemContent__lNp9x";
var _4 = "NotificationsPopup_itemDeleted__kXnQy";
var _5 = "NotificationsPopup_wrapper__a5zac";
export { _1 as "item", _2 as "itemButton", _3 as "itemContent", _4 as "itemDeleted", _5 as "wrapper" }
